<template lang="html">
  <div class="profile-profile-wrapper">
    <div v-if="!edit"  class="flexdiv">
      <div class="mainDataimg">
        <img v-if='userData.usr_image' :src='imageLink(userData.usr_image)'>
        <img v-else src='@/assets/images/defaultProfileImage.png'>
      </div>
      <div class="mainData">
        <p class="dataName">{{userData.usr_name}} {{userData.usr_username}} </p>
        <!-- <p class="dataType" v-if="userData.usr_org_type">{{userData.usr_org_type }}</p> -->
      </div>
    </div> <!-- end flexdiv-->
<!-- edit pic  -->
    <div v-else class="wrapperImgUser">
      <img v-if='imageData' class="imgUser"  :src="imageData" />
      <img v-else-if='userData.usr_image' class="imgUser" :src='imageLink(userData.usr_image)' />
      <img v-else class="imgUser" src='@/assets/images/defaultProfileImage.png'>
      <label for="myfile" ref="label" style="margin-top: 10px;" class="btn">{{$t('main.editImage')}}</label>
      <input id="myfile" type="file" accept=".png, .jpg, .jpeg" @change="photoData($event)" ref="fileInput" hidden/>
      <div class="picEdit">
         <!-- <p v-if="new_img">{{$t('item.nImage')}}: <span class="nameData">{{new_img.name}}</span></p> -->
         <button style="margin-top: 10px;" class="btn inv borderRe" v-if="new_img" @click = "resetFile">{{$t('item.remove')}} </button>
      </div> <!-- end picEdit-->
    </div> <!-- end wrapperImgUser -->

    <!-- <p v-if="errMsgPIC" class="error" >{{errMsgPIC}}</p> -->
<!--end edit pic -->
        <div class="data">
          <h1>{{$t('profile.title.profile_title')}}</h1>

          <div v-if="userData['usr_username']" class="info">
            <span class="info-key">{{$t('main.username')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_username']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_username']">
            </span>
          </div>

          <!-- SET PASS tu nastavi-->
          <!-- autocomplete="off" not working so chrome add password only in first field -->
          <input type="password" style="opacity: 0;position: absolute;">

          <div v-if="edit" class="info">
            <span class="info-key">{{$t('main.password')}}: </span>
            <span class="info-value">
              <input autocomplete="off" type="password" class="regular-input" v-model="editData['usr_password']">
            </span>
          </div>
          <div v-if="edit" class="info">
            <span class="info-key">{{$t('main.repeat_password')}}: </span>
            <span class="info-value">
              <input autocomplete="off" type="password" class="regular-input" v-model="editData['usr_password2']">
            </span>
          </div>

          <div v-if="userData['usr_email']" class="info">
            <span class="info-key">{{$t('main.email')}}: </span>
            <span class="info-value">{{userData['usr_email']}}</span>
          </div>
          <div v-if="userData['usr_name']" class="info">
            <span class="info-key">{{$t('main.nameLastName')}}: </span>
            <span v-if="!edit || userData.usr_is_organisation == 0" class="info-value">{{userData['usr_name']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_name']">
            </span>
          </div>

          <div v-if="userData['usr_phone_number'] || edit" class="info">
            <span class="info-key">{{$t('main.phone')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_phone_number']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_phone_number']">
            </span>
          </div>
           <div v-if="userData['usr_phone_number1'] || edit" class="info">
            <span class="info-key">{{$t('main.phone')}} 1: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_phone_number1']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_phone_number1']">
            </span>
          </div>
           <div v-if="userData['usr_phone_number2'] || edit" class="info">
            <span class="info-key">{{$t('main.phone')}} 2: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_phone_number2']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_phone_number2']">
            </span>
          </div>
           <div v-if="userData['usr_phone_number3'] || edit" class="info">
            <span class="info-key">{{$t('main.phone')}} 3: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_phone_number3']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_phone_number3']">
            </span>
          </div>

          <div class="info">
            <span class="info-key">{{$t('main.location')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_region']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_region']">
            </span>
          </div>

          <div v-if="userData['usr_address']" class="info">
            <span class="info-key">{{$t('main.address')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_address']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_address']">
            </span>
          </div>

          <div v-if="userData['usr_postal_code'] || edit" class="info">
            <span class="info-key">{{$t('main.usr_postal_code')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_postal_code']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_postal_code']">
            </span>
          </div>

          <div v-if="userData['usr_org_pib'] || edit" class="info">
            <span class="info-key">{{$t('main.pib')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_org_pib']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_org_pib']">
            </span>
          </div>
           <div v-if="userData['usr_org_id'] " class="info"><!-- v-if="------ || edit" -->
            <span class="info-key">{{$t('main.mbf')}}: </span>
            <span v-if="!edit || userData['usr_is_organisation']=== 1 || (userData['usr_is_organisation']=== 0 && userData['usr_org_id'] )" class="info-value">{{userData['usr_org_id']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_org_id']">
            </span>
          </div>
          <div v-if="userData['usr_org_full_name'] || edit" class="info">
            <span class="info-key">{{$t('main.usr_org_full_name')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_org_full_name']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_org_full_name']">
            </span>
          </div>

            <div v-if="userData['usr_org_bank'] || edit  " class="info">
            <span class="info-key">{{$t('main.bank')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_org_bank']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_org_bank']">
            </span>
          </div>
          <div v-if="userData['usr_org_contact'] || ( edit ) " class="info">
            <span class="info-key">{{$t('main.orgContact')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_org_contact']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_org_contact']">
            </span>
          </div>
          <div v-if="userData['usr_org_contact_person'] || ( edit ) " class="info">
            <span class="info-key">{{$t('main.usr_org_contact_person')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_org_contact_person']}}</span>
            <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['usr_org_contact_person']">
            </span>
          </div>

<!-- drustvene mreze-->
      <div v-if="userData['socials'] !== null && !edit">
          <div v-for="social in userData['socials']" :key="social.sct_id" class="info">
            <span class="info-key">{{social.sct_name}} : </span>
            <span v-if="!edit" class="info-value">{{social.link}}</span>
          </div>
    </div>
    <div v-else-if="edit">
      <div class="noFlex">
        <div v-for="social in socialsT" :key="social.sct_id" class="info">
           <span class="info-key">{{social.sct_name}}: </span>
            <span class="info-value">
              <input type="text" class="regular-input" v-model="social.link">
            </span>
          </div>
       </div>
    </div>

          <div v-if="userData['cnt_name'] || edit">
            <div v-if="!edit" class="info">
              <span class="info-key">{{$t('main.country')}}: </span>
              <span class="info-value">{{userData['cnt_name']}}</span>
            </div>
            <div v-else class="info">
              <span class="info-key">{{$t('main.country')}}: </span>
              <span class="info-value">
                <dropdown class="dropdown2"
                  :defaultText="userData['cnt_name']"
                  :selected="editData.cnt_name"
                  :list="countries"
                  @changeOption="setCountries($event)"
                />
              </span>
            </div>
          </div>
<!-- --------------------------------------------------- -->
<div v-if="userData['osr_id'] || edit" class="info">
            <span class="info-key">{{$t('main.services')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['osr_id']}}</span>
          <span v-else class="info-value">
              <input type="text" class="regular-input" v-model="editData['osr_id']">
          </span>
        </div>

        <!-- <div v-if="userData['osr_name'] || edit">
          <div v-if="!edit" class="info">
            <span class="info-key">{{$t('main.services')}}: </span>
            <span class="info-value">{{userData['osr_name']}}</span>
          </div>
          <div v-else class="info">
            <span class="info-key">{{$t('main.services')}}: </span>
            <span class="info-value">
              <dropdown class="dropdown2"
                :defaultText="userData['osr_name']"
                :selected="editData.osr_name"
                :list="organisationServices"
                @changeOption="setOrgServices($event)"
              />
            </span>
          </div>
        </div> -->

    <!--  Type of business organization - Tip firme/Oblik organizovanja*-->
    <div v-if="userData['otp_name'] || edit">
          <div v-if="!edit" class="info">
            <span class="info-key">{{$t('main.firmType')}}: </span>
            <span class="info-value">{{userData['otp_name']}}</span>
          </div>
          <div v-else class="info">
            <span class="info-key">{{$t('main.firmType')}}: </span>
            <span class="info-value">
              <dropdown class="dropdown2"
                :defaultText="userData['otp_name']"
                :selected="editData.org_name"
                :list="organisationType"
                @changeOption="setOrgType($event)"
              />
            </span>
          </div>
        </div>
<!-- --------------------------------------------------- -->
        <div v-if="userData['usr_email_language'] || edit">
          <div v-if="!edit" class="info">
            <span class="info-key">{{$t('main.usr_email_language')}}: </span>
            <span class="info-value">{{userData['usr_email_language'].toUpperCase()}}</span>
          </div>
          <div v-else class="info">
            <span class="info-key">{{$t('main.usr_email_language')}}: </span>
            <span class="info-value">
              <dropdown class="dropdown2"
                :defaultText="userData['usr_email_language']"
                :selected="editData.usr_email_language?editData.usr_email_language.toUpperCase() :editData.usr_email_language"
                :list="emailLanguage"
                @changeOption="setLanguageEmail($event)"
              />
            </span>
          </div>
        </div>

         <div v-if="!edit" class="info">
          <label class="info-key info-key2" for="notification"> {{$t('profile.sugestions.notifications')}}</label><br>
          <input class="info-value" type="checkbox" id="notification" name="vehicle1" v-model="userData.usr_notifications" disabled="disabled">
        </div>
        <div v-if="!edit" class="info">
          <label class="info-key info-key2" for="newsletter"> {{$t('profile.sugestions.newsletter')}}</label>
          <input class="info-value" type="checkbox" id="newsletter" name="vehicle2" v-model="userData.usr_newsletter" disabled="disabled">
        </div>
        <div v-if="!edit" class="info">
          <label class="info-key info-key2" for="privacy">   {{$t('profile.sugestions.privacyS')}}</label><br>
          <input class="info-value" type="checkbox" id="privacy" name="vehicle3" v-model="userData.usr_private" disabled="disabled">
        </div>

        <div v-if="edit" class="info">
          <label class="info-key info-key2" for="notification"> {{$t('profile.sugestions.notifications')}}</label><br>
          <input class="info-value" type="checkbox" id="notification" name="vehicle1" v-model="userData.usr_notifications" >
        </div>
        <div v-if="edit" class="info">
          <label class="info-key info-key2" for="newsletter"> {{$t('profile.sugestions.newsletter')}}</label>
          <input class="info-value" type="checkbox" id="newsletter" name="vehicle2" v-model="userData.usr_newsletter">
        </div>
        <div v-if="edit" class="info">
          <label class="info-key info-key2" for="privacy">   {{$t('profile.sugestions.privacyS')}}</label><br>
          <input class="info-value" type="checkbox" id="privacy" name="vehicle3" v-model="userData.usr_private">
        </div>

         <div v-if="userData['usr_business_register'] ||  edit" class="info">
            <span class="info-key info-key2">{{$t('main.apr1')}}: </span>
            <span v-if="!edit" class="info-value"><a :href="imageLink(userData['usr_business_register'])"><img :src="require('@/assets/icons/downloadDocument.png')"></a></span>
            <span v-else class="info-value infoFile">
              <label class="btn" for="apr">{{$t('profile.sugestions.file')}}</label>
              <button  style="margin:0 5px" class="btn inv borderRe" v-if="usr_business_register !== null" @click = "resetAprFile">{{$t('item.remove')}} </button>
              <span v-if="usr_business_register">{{usr_business_register.name}}</span>
              <input type="file" id="apr" @change="apr($event)" ref="apr" hidden />
            </span>
          </div>

         <div v-if="userData['usr_tax_info'] || edit" class="info">
            <span class="info-key info-key2">{{$t('main.file')}}:</span>
            <span v-if="!edit" class="info-value"><a :href="imageLink(userData['usr_tax_info'])"><img :src="require('@/assets/icons/downloadDocument.png')" /></a></span>
            <span v-else class="info-value infoFile">
              <label class="btn" for="taxInfo">{{$t('profile.sugestions.file')}}</label>
              <button  style="margin:0 5px" class="btn inv borderRe" v-if="usr_tax_info !== null" @click = "resetTaxFile">{{$t('item.remove')}} </button>
              <span v-if="usr_tax_info">{{usr_tax_info.name}}</span>
              <input type="file" id="taxInfo" @change="taxInfo($event)" ref="tax"  hidden />
            </span>
          </div>

          <div v-if="userData['usr_pr_text'] || edit" class="info">
            <span class="info-key info-key2">{{$t('main.pr')}}: </span>
            <span v-if="!edit" class="info-value">{{userData['usr_pr_text']}}</span>
            <span v-else class="info-value">
              <textarea  type="txt" class="regular-input txt" maxlength="999" v-model="usr_pr_text"></textarea >
            </span>
          </div>

           <div v-if="userData['usr_rating']" class="info">
             <span class="info-key">{{$t('item.rate')}}: </span>
             <span class="info-value">
               <rating :rating="parseFloat(userData['usr_rating'])" />
             </span>
           </div>
           <!-- <p v-if="errMsg" class="error" >{{errMsg}}</p> -->
       </div>

       <div v-if="!edit" @click="editable === false ? edit = false : edit = true" :class="{ disabled : !editable }" class="btn">
         <p>{{$t("button.button_edit_data")}}</p>
       </div>
       <div v-else class="btn-wrapper">
         <div else @click="edit = false" class="btn inv">
           <p>{{$t("button.button_cancel")}}</p>
         </div>
         <div else @click="save" class="btn">
           <p>{{$t("button.button_save")}}</p>
         </div>
       </div>

    <div v-if="!editable">
      <div class="info">
        <span class="info-key">{{$t('main.profilEditForbiden')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { api, baseURL } from '@/api'
import dropdown from '@/components/dropdown.vue'
import Rating from '@/components/rating.vue'
import { mapState } from 'vuex'

export default {
  name: 'profileProfile',
  components: {
    dropdown,
    Rating
  },
  data () {
    return {
      editable: true,
      userData: {},
      mainData: [
        'usr_email',
        'usr_phone_number',
        'usr_phone_number1',
        'usr_phone_number2',
        'usr_phone_number3',
        'usr_username',
        'usr_name',
        'usr_password',
        'usr_password2',
        'cnt_name',
        'usr_region',
        'usr_address',
        'usr_org_pib',
        'org_type',
        'usr_org_bank',
        'osr_name',
        'osr_id',
        'otp_name',
        'org_services',
        'usr_org_contact',
        'usr_org_contact_person',
        'usr_org_id',
        'usr_rating',
        'socials',
        'usr_postal_code',
        'usr_tax_info',
        'usr_business_register',
        'usr_email_language',
        'usr_org_full_name'
        // 'usr_pr_text'
      ],
      organisationType: [],
      organisationServices: [],
      countries: [],
      socialsT: [],
      socials: [],
      edit: false,
      editData: {},
      errMsg: null,
      errMsgPIC: null,
      imageData: '',
      new_img: null,
      notification: false,
      newsletter: false,
      privacy: false,
      usr_business_register: null,
      usr_tax_info: null,
      sendData: {},
      usr_pr_text: null,
      emailLanguage: [
        { label: 'RS', value: 'rs' },
        { label: 'EN', value: 'en' }
      ]
    }
  },
  computed: {
    ...mapState(['userName'])
  },
  watch: {
    'mainData.osr_name': {
      handler (newVal) {
        console.log(newVal)
      }
    }
  },
  methods: {
    async getSocialTypes () {
      await api.getSocialTypes().then(res => {
        console.log(res.data.data)
        this.socialsT = res.data.data
        this.setSocial()
      })
    },
    setSocial () {
      for (let i = 0; i < this.socialsT.length; i++) {
        this.socialsT[i].link = ''
      }
      if (this.userData['socials'] !== null) {
        for (let i = 0; i < this.socialsT.length; i++) {
          for (let j = 0; j < this.userData.socials.length; j++) {
            if (this.socialsT[i].sct_id == this.userData.socials[j].sct_id) {
              this.socialsT[i].link = this.userData.socials[j].link
            }
          }
        }
      }
    },
    save () {
      this.setDataForSend()
      if (!this.matchMail(this.editData.usr_email)) {
        this.$toast.error(this.$t('errors.registration.email'), {
          duration: 8000
        })
        return
      }
      if (!this.matchPhone(this.editData.usr_phone_number)) {
        this.$toast.error(this.$t('errors.registration.phone'), {
          duration: 8000
        })
        return
      }
      if (this.editData.usr_password === null || this.editData.usr_password === '') {
        delete this.editData.usr_password
        delete this.editData.usr_password2
      } else {
        if (this.editData.usr_password && this.editData.usr_password != this.editData.usr_password2) {
          console.log('ghjdnxhjwkniwdhjkmeqiaujh')
          this.$toast.error(this.$t('errors.registration.errorB'), {
            duration: 8000
          })
          return
        }
        /* if (this.editData.usr_password.length < 8) {
          this.errMsg = this.$t('errors.registration.password')
          return
        } */
      }
      if (this.mustHaveValue(this.sendData)) return

      // this.editData.usr_notifications = (this.userData.usr_notifications === true || this.userData.usr_notifications === 1) ? 1 : 0
      // this.editData.usr_newsletter = (this.userData.usr_newsletter === true || this.userData.usr_newsletter === 1) ? 1 : 0
      // this.editData.usr_private = (this.userData.usr_private === true || this.userData.usr_private === 1) ? 1 : 0
      this.editData.socials = JSON.stringify(this.socialsT)
      this.sendData.socials = this.editData.socials
      // if (this.sendData.hasOwnProperty('usr_notifications')) this.sendData.usr_notifications = (this.userData.usr_notifications === true || this.userData.usr_notifications === 1) ? 1 : 0
      // if (this.sendData.hasOwnProperty('usr_newsletter')) this.sendData.usr_newsletter = (this.userData.usr_newsletter === true || this.userData.usr_newsletter === 1) ? 1 : 0
      // if (this.sendData.hasOwnProperty('usr_private')) this.sendData.usr_private = (this.userData.usr_private === true || this.userData.usr_private === 1) ? 1 : 0
      this.sendData.usr_notifications = (this.userData.usr_notifications === true || this.userData.usr_notifications === 1) ? 1 : 0
      this.sendData.usr_newsletter = (this.userData.usr_newsletter === true || this.userData.usr_newsletter === 1) ? 1 : 0
      this.sendData.usr_private = (this.userData.usr_private === true || this.userData.usr_private === 1) ? 1 : 0

      console.log(this.userData.usr_notifications + '  - ' + this.sendData.usr_notifications + 'this.userData.usr_newsletter')

      let params = this.paramsAppend(this.sendData)
      if (this.imageData !== '') {
        this.editData.image = this.new_image
        params.append('image', this.new_img)
      }
      if (this.usr_business_register !== null) {
        params.append('usr_business_register', this.usr_business_register)
      }
      if (this.usr_tax_info !== null) {
        params.append('usr_tax_info', this.usr_tax_info)
      }
      if (this.usr_pr_text !== null && this.usr_pr_text !== '') {
        params.append('usr_pr_text', this.usr_pr_text)
      }
      // send data------------------------------------
      api.editProfileData(params).then(res => {
        console.log(res)
        if (res.data.res === 'ok') {
          this.getUserInfo()
          this.edit = false
          this.usr_business_register = null
          this.usr_tax_info = null
          this.usr_pr_text = null
          this.$toast.success(this.$t('main.successfulEditProfile'), {
            duration: 8000
          })
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }, 200)
          return
        }
        this.$toast.error(this.$t('errors.registration.errorB'), {
          duration: 8000
        })
      }).catch(e => {
        this.handleErrors(e.response)
      })
      // this.edit = false
    },
    handleErrors (response) {
      console.log(response)
      if (response.status === 403) {
        this.$toast.error(this.$t('errors.profile.forbiden'), {
          duration: 8000
        })
      }
      if (response.status === 409) {
        this.$toast.error(this.$t('errors.profile.min.username_err'), {
          duration: 8000
        })
        return
      }
      if (response.data.validation && response.data.validation === 'min') {
        this.$toast.error(this.$t('errors.profile.min.' + response.data.name), {
          duration: 8000
        })
      }
      this.getUserInfo()
      this.edit = false
    },
    getUserInfo () {
      api
        .getUserInfo()
        .then(res => {
          this.userData = res.data.data
          this.editable = res.data.editable
          if (this.userData.usr_username !== this.userName) {
            this.$store.commit('setUserName', this.userData.usr_username)
            localStorage.setItem('userName', this.userData.usr_username)
          }
          this.setUpEditData()
          this.getSocialTypes()
        })
        .catch(e => {
          console.log(e)
        })
    },
    mustHaveValue (userData) {
      if (this.userData.usr_is_organisation !== 1) { return false }
      for (var variable in userData) {
        console.log('variable' + variable + 'userData[variable]' + userData[variable])
        if ((variable === 'org_pib' || variable === 'org_id' || variable === 'org_type' || variable === 'org_contact' || variable === 'usr_org_contact_person' || variable === 'sr_org_registration_number' || variable === 'usr_org_full_name' || variable === 'usr_org_bank') && (userData[variable] === '' || userData[variable] === null || userData[variable] === undefined)) {
          this.$toast.error(this.$t('errors.profile.empty_field'), {
            duration: 8000
          })
          return true
        }
      }

      return false
    },
    imageLink (image) {
      return baseURL + image
    },
    setUpEditData () {
      for (var variable in this.userData) {
        if (this.userData.hasOwnProperty(variable)) {
          this.editData[variable] = this.userData[variable]
        }
      }
      this.usr_pr_text = this.userData['usr_pr_text']
      this.editData.usr_password = null
      this.editData.usr_password2 = null
    },
    setDataForSend () {
      this.sendData = {}
      for (var i = 0; i < this.mainData.length; i++) {
        // if (this.editData.hasOwnProperty(variable)) {
        if (this.editData[this.mainData[i]] != this.userData[this.mainData[i]]) {
          if (this.mainData[i] == 'osr_id') {
            this.sendData['org_services'] = this.editData[this.mainData[i]]
          } else if (this.mainData[i] == 'cnt_name') {
            console.log(this.editData[this.mainData[i]])
            this.sendData['cnt_id'] = this.editData[this.mainData[i]].value
          } else {
            this.sendData[this.mainData[i]] = this.editData[this.mainData[i]]
          }
        }
        //   }
        // if (this.editData.usr_email_language !== undefined && this.editData.usr_email_language !== null) {
        //   this.sendData['usr_email_language'] = this.editData['usr_email_language']
        // }
      }
      // if (this.userData['usr_is_organisation'] !== 1) {
      //   if (this.editData['usr_org_full_name'] !== undefined && this.editData['usr_org_full_name'] !== '') this.sendData['usr_org_full_name'] = this.editData['usr_org_full_name']
      //   if (this.editData['usr_org_bank'] !== undefined && this.editData['usr_org_bank'] !== '') this.sendData['usr_org_bank'] = this.editData['usr_org_bank']
      //   if (this.editData['usr_org_id'] !== undefined && this.editData['usr_org_id'] !== '') this.sendData['usr_org_id'] = this.editData['usr_org_id']
      //   if (this.editData['usr_org_pib'] !== undefined && this.editData['usr_org_pib'] !== '') this.sendData['usr_org_pib'] = this.editData['usr_org_pib']
      //   if (this.editData['usr_org_contact_person'] !== undefined && this.editData['usr_org_contact_person'] !== '') this.sendData['usr_org_contact_person'] = this.editData['usr_org_contact_person']
      // }
      return this.sendData
    },
    setDataForSendOld () {
      this.sendData = {}
      for (var i = 0; i < this.mainData.length; i++) {
        // if (this.editData.hasOwnProperty(variable)) {
        if (this.editData[this.mainData[i]] !== this.userData[this.mainData[i]]) {
          if (this.mainData[i] === 'otp_name') {
            this.sendData['org_type'] = this.editData[this.mainData[i]]
          } else { this.sendData[this.mainData[i]] = this.editData[this.mainData[i]] }
        }
        //   }
        // if (this.editData.usr_email_language !== undefined && this.editData.usr_email_language !== null) {
        //   this.sendData['usr_email_language'] = this.editData['usr_email_language']
        // }
      }
      // if (this.userData['usr_is_organisation'] !== 1) {
      //   if (this.editData['usr_org_full_name'] !== undefined && this.editData['usr_org_full_name'] !== '') this.sendData['usr_org_full_name'] = this.editData['usr_org_full_name']
      //   if (this.editData['usr_org_bank'] !== undefined && this.editData['usr_org_bank'] !== '') this.sendData['usr_org_bank'] = this.editData['usr_org_bank']
      //   if (this.editData['usr_org_id'] !== undefined && this.editData['usr_org_id'] !== '') this.sendData['usr_org_id'] = this.editData['usr_org_id']
      //   if (this.editData['usr_org_pib'] !== undefined && this.editData['usr_org_pib'] !== '') this.sendData['usr_org_pib'] = this.editData['usr_org_pib']
      //   if (this.editData['usr_org_contact_person'] !== undefined && this.editData['usr_org_contact_person'] !== '') this.sendData['usr_org_contact_person'] = this.editData['usr_org_contact_person']
      // }
      return this.sendData
    },
    // ---  Type of business organization - Tip firme/Oblik organizovanja*
    getOrganisationType () {
      api.getOrganisationType().then(res => {
        let data = res.data.data
        for (let i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].otp_name,
            value: data[i].otp_id
          }
          console.log(data[i].otp_name)
          this.organisationType.push(obj)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // do not needed
    getOrganisationServices () {
      api.getOrganisationServices().then(res => {
        let data = res.data.data
        for (let i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].osr_name,
            value: data[i].osr_id
          }
          this.organisationServices.push(obj)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getCountries () {
      api.getCountries().then(res => {
        let data = res.data.data
        for (var i = 0; i < data.length; i++) {
          let obj = {
            label: data[i].cnt_name,
            value: data[i].cnt_id
          }
          this.countries.push(obj)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    setOrgType (e) {
      console.log(e)
      this.editData.org_name = e
      this.editData.org_type = e.value
      this.editData = Object.assign({}, this.editData)
    },
    setOrgServices (e) {
      console.log(JSON.stringify(e))
      this.editData.osr_name = e
      this.editData.osr_id = e.value
      this.editData.org_services = e
      this.editData = Object.assign({}, this.editData)
    },
    setCountries (e) {
      console.log(e.value)
      this.editData.cnt_name = e
      this.editData.usr_country = e.value
      this.editData = Object.assign({}, this.editData)
    },
    setLanguageEmail (e) {
      this.editData.usr_email_language = e.value
      this.editData = Object.assign({}, this.editData)
    },
    matchMail (v) {
      let mailformat = /^(\w+.?)+@(\w+.?)+\.\w+$/
      if (v.match(mailformat)) {
        return true
      } return false
    },
    matchPhone (v) {
      let phoneformat = /^(\+|0{2})(\d ?){7,15}$/
      if (v.match(phoneformat)) {
        return true
      } return false
    },
    photoData (e) {
      this.new_img = e.target.files[0]

      if (this.new_img) {
        if (this.new_img.size > 409600) {
          this.$toast.error(this.$t('errors.registration.bigImage'), {
            duration: 8000
          })
          this.resetFile()
          return
        }
        let reader = new FileReader()
        reader.onload = (e) => {
          this.imageData = e.target.result
        }
        console.log(this.new_img)
        reader.readAsDataURL(this.new_img)
      }
    },
    resetFile () {
      let input = this.$refs.fileInput
      input.type = 'text'
      input.type = 'file'
      this.new_img = null
      this.imageData = ''
    },
    apr (e) {
      // this.usr_business_register = null
      // this.editData.usr_business_register = e.target.files[0]
      console.log(e.target.files[0])
      this.usr_business_register = e.target.files[0]
      console.log(this.usr_business_register)
    },
    resetAprFile () {
      let input = this.$refs.apr
      input.type = 'text'
      input.type = 'file'
      this.usr_business_register = null
    },
    taxInfo (e) {
      // this.usr_tax_info = null
      console.log(e.target.files[0])
      this.usr_tax_info = e.target.files[0]
      console.log(this.usr_tax_info)
    },
    resetTaxFile () {
      let input = this.$refs.tax
      input.type = 'text'
      input.type = 'file'
      this.usr_tax_info = null
    },
    paramsAppend (obj) {
      let params = new FormData()
      for (let x in obj) {
        params.append(x, obj[x])
      }
      return params
    }
  },
  mounted () {
    // this.getUserInfo()
    // this.getOrganisationType()
    // this.getOrganisationServices()
    // this.getCountries()
  },
  activated () {
    this.getUserInfo()
    this.getOrganisationType()
    this.getOrganisationServices()
    this.getCountries()
  },
  deactivated () {
    this.edit = false
  }
}
</script>

<style lang="scss" scoped>

.profile-profile-wrapper {
  text-align: left;
  padding:  0 46px 46px 46px;
  @import '@/assets/scss/btnStyles.scss';
  .infoFile{
    display:flex;
    // flex-wrap: wrap;
    align-items: center;
  }
  .regular-input{
    border: 1.5px solid rgba(0, 0, 0, 0.06);
  }
  .regular-input:focus{
    outline: none;
  }
  .txt{
    height:initial;
  }
  .file{
    opacity: 0.5;
  }
  .file::nth-of-type(2){
    margin-top:15px !important;
  }
  .btn {
    width: 120px;
    font-size: 9px;
  }
  .btn.disabled {
    // pointer-events: none;
    cursor: not-allowed;
  }
  .paddTop{
    // padding-top: 20px;
  }
  .error{
          opacity: 1;
          color: #CB3737 !important;
          margin-left: auto;
        }
  .btn-wrapper {
    display: flex;
    flex-direction: row;
    .btn:first-child {
      margin-right: 10px;
    }
  }

  .flexdiv {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .mainDataimg {
      width: 60px;
      height: 60px;
      overflow: hidden;
      border-radius: 6px;

      img {
        width: 100%;
      }
    }
    .mainData {
      padding-left: 7px;

      .dataName {
        margin-bottom: 0;
        padding-bottom: 0;
        font-style: normal;
        font-weight: bold;
        font-size: 17px;
        line-height: 28px;
        /* identical to box height */

        letter-spacing: 0.04em;

        color: $text-color;
      }
      .dataType {
        margin-top: 0;
        font-style: normal;
        font-weight: bold;
        font-size: 13px;

        color: #af3835;
      }
    }
  }
  .data {
    margin-bottom: 53px;
    h1 {
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      line-height: 30px;
      letter-spacing: 0.06em;
      margin-bottom: 30px;
      color: $text-color;
    }

    p,.info-value {
      font-style: normal;
      font-weight: 500;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.04em;
      padding: 20;
      color: #606060;
    }

    .span {
      text-transform: uppercase;
      font-style: normal;
      font-weight: 800;
      font-size: 9.5px;
      line-height: 15px;
      letter-spacing: 0.05em;

      color: rgba(160, 160, 160, 0.8);

    }
  }

}

.info {
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  align-items: center;

  .info-key {
    // text-transform: uppercase;
    font-weight: normal;
    font-size: 10.5px;
    line-height: 21px;
    color: rgba(160, 160, 160, 0.8);
    margin-right: 15px;
    white-space: nowrap;
    min-width: 150px;
  }
  .info-key2{
    width: 150px;
    white-space:initial !important;
  }
  .info-value {
    font-weight: 800;
    font-size: 13px;
    line-height: 21px;
    letter-spacing: 0.02em;
    color: $text-color;
  }
}
.checkDiv{
  padding-right: 20px;

}

.wrapperImgUser{
            box-sizing:border-box;
            padding: 30px 0 0 0;
            display:flex;
           flex-direction: column;
            /*  justify-content: center;
              align-items: center; */

        .imgUser{
           width:100%;
              object-fit: cover;
              height:100px;
              width: 100px;
          }
          .editImg{
            padding-left: 5px;
            font-family: Gotham Pro;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 50px;
            /* identical to box height, or 357% */
            /* Gray 3 text */

            color: #92949B;

          }
          .picEdit{
              color: #787883;
            .remove_pic{
                background: #FFFFFF;
                padding: 3px 0;
                color: #92949B;
                border: 1px solid #92949B;
                box-sizing: border-box;
                border-radius: 15px;
            }

          }
        }
  .noFlex{
    display:block !important;
  }

@media screen and (max-width: 1000px ) {
  .profile-profile-wrapper {
    padding:  10px;
  }
}

</style>
<style lang="scss">
.profile-profile-wrapper {
  .dropdown {
    width: 100%;
    min-width: 200px !important;
  }
  .option {
    overflow-wrap: break-word;
    height: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
    // width: 100%;
    white-space: normal !important;
  }
}
.borderRe{
  border: 0 !important;
}

</style>
